;(function () {
	const initSlider = (slider) => {
		if (slider.swiper) {
			return;
		}

		slider.classList.add('swiper');
		const wrapper = slider.querySelector('.multicolumn-list__wrapper');
		if (!wrapper) return;
		wrapper.classList.add('swiper-wrapper');

		const slides = slider.querySelectorAll('.multicolumn-card');
		if (!slides || !slides.length) return;
		slides.forEach((slide) => {
			slide.classList.add('swiper-slide');
		});

		const section = slider.closest('.multicolumn-section');
		const paginationEl = section.querySelector('.multicolumn__pagination');
		const navigationEl = section.querySelector('.multicolumn__navigation');
		const nextEl = navigationEl?.querySelector('.multicolumn__button-next');
		const prevEl = navigationEl?.querySelector('.multicolumn__button-prev');

		new Swiper(slider, {
			loop: false,
			slidesPerView: 1.1,
			breakpoints: {
				950: {
					slidesPerView: 3.1,
				},
				650: {
					slidesPerView: 2.1,
				}
			},
			spaceBetween: 20,
			speed: 1000,
			mousewheel: {
				forceToAxis: true,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			navigation: {
				nextEl: nextEl,
				prevEl: prevEl,
			},
		});
	}

	const destroySlider = (section) => {
		const slider = section.querySelector('.multicolumn-slider');
		if (slider && slider.swiper) {
			slider.swiper.destroy(true, true);
		}
	}

	const initMulticolumn = (section) => {
		const slider = section.querySelector('.multicolumn-slider');
		if (slider) {
			initSlider(slider);
		}
	}

	document.querySelectorAll('.multicolumn-section').forEach(section => {
        if (section.querySelector('.multicolumn-slider')) {
            initMulticolumn(section);
        }
    });

	document.addEventListener('shopify:section:load', function (e) {
		if (e.target.classList.contains('multicolumn-section')) {
			initMulticolumn(e.target);
		}
	});

	document.addEventListener('shopify:section:unload', function (e) {
		if (e.target.classList.contains('multicolumn-section')) {
			destroySlider(e.target);
		}
	});

})();